import React from "react";
import classNames from "classnames";
import useBreadcrumbs from "./useReactRouterBreadcrumbs";

import { Link } from "react-router";

interface Props {
  extraClasses?: string;

  // eslint-disable-next-line
  routes: any;

  onClickFunction?: Function;
}

export const Breadcrumb: React.FC<Props> = (props: Props): JSX.Element => {
  const { extraClasses, routes, onClickFunction } = props;
  const breadcrumbs = useBreadcrumbs(routes);

  const classes = classNames("caprx-breadcrumb-wrapper", extraClasses);

  // eslint-disable-next-line
  const breadcrumbClick = (breadcrumb: any): void => {
    if (onClickFunction) {
      if (breadcrumb.props.children) onClickFunction(breadcrumb.props.children);
      else onClickFunction(breadcrumb.props.label);
    }
  };

  return (
    <div className={classes}>
      {/* @ts-ignore */}
      {breadcrumbs.map(({ match, breadcrumb }, index) => {
        let breadcrumbItem = (
          <React.Fragment key={match.pathname}>
            <Link
              to={match.pathname}
              onClick={(): void => {
                breadcrumbClick(breadcrumb);
              }}
            >
              {breadcrumb}
            </Link>
            <span className="caprx-icon-inputarrowcaretright" />
          </React.Fragment>
        );

        if (breadcrumbs.length - 1 === index) {
          breadcrumbItem = <span key={match.pathname}>{breadcrumb}</span>;
        }

        return breadcrumbItem;
      })}
    </div>
  );
};
